const BASE_URL = 'https://api.successionnow.com/api/v1/';
      API_URL = 'https://api.successionnow.com/';
export default BASE_URL;
export  var API_URL;